<template>
<div class="chapter">
<div class="inner_page">
<h1>Rocket Summer</h1>
<h2 class="sigil_not_in_toc">And two more stories</h2>
<h2 class="sigil_not_in_toc">Ray Bradbury</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?81f1173a